import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Emty from "../../components/Emty/Emty";
import PostListSection from "../../components/PostListSection/PostListSection";
import UseProjectCommon from "../../hooks/UseProjectCommon";
import ListSearchSection from "../../components/ListSearchSection/ListSearchSection";
function Startlist() {
  const category = useLocation().pathname.split("/")[1] as "prjt" | "mtup";
  const [data, ProjectDelete, SearchProject, ProjectPause] = UseProjectCommon({
    type: category,
    filter:
      "&prjt_sts_cd=prjt_sts_rcrt_ing,prjt_sts_rcrt_wait,prjt_sts_rcrt_paus&prjt_sort_order=rcrt",
    time: ``,
  });
  return (
    <main className="startlist">
      <div className="wrapper">
        <ListSearchSection
          title={`모집중 ${category === "prjt" ? "프로젝트" : "밋업"}`}
          placeholder={category === "prjt" ? "프로젝트 검색" : "밋업명 검색"}
          isExel={false}
          filter={[]}
          Search={SearchProject}
        />
        {data.length > 0 ? (
          <PostListSection
            type="start"
            tags={tag_layout}
            data={data}
            PostRemove={ProjectDelete}
            ProjectPause={ProjectPause}
            category={undefined}
            ChangeProjectSts={undefined}
            __ChangeState={undefined}
            prjtData={undefined}
          />
        ) : (
          <Emty />
        )}
      </div>
    </main>
  );
}

export default Startlist;

const tag_layout = [
  {
    type: "start-title",
    title: "프로젝트명",
  },
  {
    type: "start-time",
    title: "모집마감일",
  },
  {
    type: "start-leader",
    title: "팀플리더",
  },
  {
    type: "start-number",
    title: "모집인원",
  },
  {
    type: "start-state",
    title: "상태",
  },
  {
    type: "start-delete",
    title: "삭제하기",
  },
];
